import { useStyles } from '@webapps/styles';
import { useState, useEffect } from 'react';
import { PaginationNumbers, useAuth, useQuery } from '@webapps/reactjs-tech-components';
import { getRecordDocumentsList } from '@webapps/business';
import { useFormik } from 'formik';
import { CircularProgress, Grid } from '@material-ui/core';
import { useLocation, useHistory } from 'react-router-dom';
import DocumentCard from './DocumentCard';

const Document = ({ opcoRecord, refetch }) => {
  const { classes, css, cx, global } = useStyles(styles);

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(8);

  const { data: { content: documents = [], totalElements } = {}, isLoading} = useQuery(getRecordDocumentsList, {
    key: ['documentsRecord', size, page],
    variables: {
      id: opcoRecord?.id,
      size,
      page: page - 1
    },
    keepPreviousData: true
  });

  return (
    <div className={cx(global.fcjs, classes.gap)}>
      {documents?.length > 0 ? documents?.map((document) => (
        <Grid key={document.id} item xs={12} sm={6} md={4} xl={3} style={{ padding: '0 20px 20px 0' }}  >
          <DocumentCard document={document} opcoRecord={opcoRecord} refetch={refetch} />
        </Grid>
      )) : (
        <div>
          {isLoading ? <CircularProgress style={{ color: '#152652' }} /> : 'Aucun document trouvé'}
        </div>
      )}
      <PaginationNumbers
        onChange={(newPage) => setPage(newPage)}
        page={page}
        pageCount={size}
        totalCount={totalElements}
      />
    </div>
  );
};

const styles = ({ fontSizes, spacing }) => ({
  gap: {
    gap: 40,
  }
});

export default Document;